/** saves Savings History list
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_operations
*/
export const SAVE_SAVINGS_HISTORY_LIST = (state, { pageNumber, data }) => {
    state.historyList = pageNumber === 1 ? data.customerOperations : state.historyList.concat(data.customerOperations)

    state.historyListHasMore = data.hasMore
}

export const SAVE_STATUS_LIST = (state, payload) => {
    state.statusList = payload.statusList
}

export const SAVE_CHANNELS_LIST = (state, payload) => {
    state.channelsList = payload
}

/** saves the operation details
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_operationsdetails_
*/
export const SAVE_OPERATION_DETAILS = (state, payload) => {
    state.operationDetails = payload.lineGroups
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_FEATURE_STATE = (state, payload) => {
	state.historyList = []
	state.historyListHasMore = false
    state.statusList = []
    state.channelsList = []
    state.operationDetails = []
}
